import { PaperClipOutlined, TagOutlined } from "@ant-design/icons";
import { ReactComponent as AccountSettingsIcon } from "../../assets/AccountSettingsIcon.svg";
import { ReactComponent as ProductsIcon } from "../../assets/ProductsIcon.svg";
import { ReactComponent as SupportIcon } from "../../assets/SupportIcon.svg";
import { ReactComponent as SignoutIcon } from "../../assets/SignOutIcon.svg";
import { ReactComponent as PrescriberIcon } from "../../assets/prescriberIcon.svg";
import { ReactComponent as TranslatorIcon } from "../../assets/TranslatorIcon.svg";
import { ReactComponent as ConciergeIcon } from "../../assets/ConciergeIcon.svg";

import { useAuth } from "../hooks/useAuth";
import { GetProp, MenuProps, Tooltip } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";

export const useSideBarMenu = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [open, setOpen] = useState(false);

  type MenuItem = GetProp<MenuProps, "items">[number];

  const handleMenuClick = (url: string) => {
    if (url === "Support") {
      window.location.href = "mailto:support@docupdate.io";
    } else {
      navigate(url);
    }
    setOpen(false);
  };

  const handleNavMenuClick = (url: string) => {
    window.open(url, "_blank");
  };

  const MENU_INFO: MenuItem[] = [
    {
      key: "1",
      label: <Tooltip title="Account Setting">Account Setting</Tooltip>,
      icon: <AccountSettingsIcon className="w-full object-cover max-w-10" />,
      onClick: () => handleMenuClick("/advisory-board-portal-new"),
      className:
        "flex items-center font-semibold font-urbanist text-[15px] bg-transparent p-[1.68rem_1rem] text-white",
    },
    {
      key: "2",
      label: "Products",
      icon: <ProductsIcon className="w-full object-cover max-w-10" />,
      children: [
        {
          key: "21",
          label: <Tooltip title="Advisory Board">Advisory Board</Tooltip>,
          icon: <TagOutlined className="w-full object-cover max-w-5" />,
          className:
            "flex items-center font-semibold font-urbanist text-[15px] bg-transparent p-[1.68rem_1rem] text-white product-menu",
          onClick: () => handleMenuClick("/advisory-board-new"),
        },
        {
          key: "22",
          label: <Tooltip title="Prescriber App">Prescriber App</Tooltip>,
          icon: <PaperClipOutlined className="w-full object-cover max-w-5" />,
          className:
            "flex items-center font-semibold font-urbanist text-[15px] bg-transparent p-[1.68rem_1rem] text-white product-menu",
          onClick: () => handleMenuClick("/ePrescribe"),
        },
      ],
    },
    {
      key: "3",
      label: "Support",
      icon: <SupportIcon className="w-full object-cover max-w-10" />,
      className:
        "flex items-center font-semibold font-urbanist text-[15px] bg-transparent p-[1.68rem_1rem] text-white",
      onClick: () => handleMenuClick("Support"),
    },
    {
      key: "4",
      label: "Sign Out",
      icon: <SignoutIcon className="w-full object-cover max-w-10" />,
      className:
        "flex items-center font-semibold font-urbanist text-[15px] bg-transparent p-[1.68rem_1rem] text-white",
      onClick: () => logout(),
    },
  ];

  const MENU_INFO_MOBILE: MenuItem[] = [
    {
      key: "1",
      label: "Account Setting",
      icon: <AccountSettingsIcon className="w-full object-cover max-w-10" />,
      onClick: () => handleMenuClick("/advisory-board-portal-new"),
      className:
        "flex items-center font-semibold font-urbanist text-[15px] bg-transparent p-[1.68rem_1rem] text-white",
    },
    {
      key: "2",
      label: "Products",
      icon: <ProductsIcon className="w-full object-cover max-w-10" />,
      children: [
        {
          key: "21",
          label: "Advisory Board",
          icon: <TagOutlined className="w-full object-cover max-w-5" />,
          className:
            "flex items-center font-semibold font-urbanist text-[15px] bg-transparent p-[1.68rem_1rem] text-white product-menu",
          onClick: () => handleMenuClick("/advisory-board-new"),
        },
        {
          key: "22",
          label: "Prescriber App",
          icon: <PaperClipOutlined className="w-full object-cover max-w-5" />,
          className:
            "flex items-center font-semibold font-urbanist text-[15px] bg-transparent p-[1.68rem_1rem] text-white product-menu",
          onClick: () => handleMenuClick("/ePrescribe"),
        },
      ],
    },
    {
      key: "3",
      label: "Support",
      icon: <SupportIcon className="w-full object-cover max-w-10" />,
      className:
        "flex items-center font-semibold font-urbanist text-[15px] bg-transparent p-[1.68rem_1rem] text-white",
      onClick: () => handleMenuClick("Support"),
    },
    {
      key: "4",
      label: "Sign Out",
      icon: <SignoutIcon className="w-full object-cover max-w-10" />,
      className:
        "flex items-center font-semibold font-urbanist text-[15px] bg-transparent p-[1.68rem_1rem] text-white",
      onClick: () => logout(),
    },
  ];

  const NAVBAR_INFO_MOBILE: MenuItem[] = [
    {
      key: "1",
      label: "Prescriber",
      icon: <PrescriberIcon className="w-full object-cover max-w-5" />,
      className:
        "flex items-center font-playfair text-2xl bg-transparent p-[1.68rem_1rem] text-[#101935] product-menu hover:bg-[#E9EAEB]",
      onClick: () => handleNavMenuClick("https://www.docupdate.io/prescriber/"),
    },
    {
      key: "2",
      label: "Translator",
      icon: <TranslatorIcon className="w-full object-cover max-w-5" />,
      className:
        "flex items-center font-playfair text-2xl bg-transparent p-[1.68rem_1rem] text-[#101935] product-menu hover:bg-[#E9EAEB]",
      onClick: () => handleNavMenuClick("https://www.docupdate.io/translator/"),
    },
    {
      key: "3",
      label: "Concierge",
      icon: <ConciergeIcon className="w-full object-cover max-w-5" />,
      className:
        "flex items-center font-playfair text-2xl bg-transparent p-[1.68rem_1rem] text-[#101935] product-menu hover:bg-[#E9EAEB]",
      onClick: () => handleNavMenuClick("https://www.docupdate.io/concierge/"),
    },
    {
      key: "4",
      label: "Manage Preferences",
      className:
        "flex items-center font-playfair text-2xl bg-transparent p-[1.68rem_1rem] text-[#101935] product-menu hover:bg-[#E9EAEB]",
      onClick: () =>
        handleNavMenuClick("https://www.docupdate.io/manage-preferences/"),
    },
  ];

  const POPUP_CONTENT = (
    <ul className="flex flex-col w-full max-w-[300px] gap-y-2">
      <Link
        to={"https://www.docupdate.io/prescriber/"}
        className="p-2 hover:bg-[#E9EAEB] rounded-[16px]"
      >
        <li className="flex flex-col gap-y-2">
          <div className="flex gap-x-2 font-semibold text-lg justify-start">
            <PrescriberIcon className="w-full object-cover max-w-5" />
            <span className="font-playfair text-[#101935]">Prescriber</span>
          </div>
          <div className="text-[#535862] font-inter text-base ml-6">
            Your Prescribing Assistant
          </div>
        </li>
      </Link>
      <Link
        to={"https://www.docupdate.io/translator/"}
        className="p-2 hover:bg-[#E9EAEB] rounded-[16px]"
      >
        <li className="flex flex-col gap-y-2">
          <div className="flex gap-x-2 font-semibold text-lg justify-start">
            <TranslatorIcon className="w-full object-cover max-w-5" />
            <span className="font-playfair text-[#101935]">Translator</span>
          </div>
          <div className="text-[#535862] font-inter text-base ml-6">
            Secure Medical Translator for Multilingual Patient Communication
          </div>
        </li>
      </Link>
      <Link
        to={"https://www.docupdate.io/concierge/"}
        className="p-2 hover:bg-[#E9EAEB] rounded-[16px]"
      >
        <li className="flex flex-col gap-y-2">
          <div className="flex gap-x-2 font-semibold text-lg justify-start">
            <ConciergeIcon className="w-full object-cover max-w-5" />
            <span className="font-playfair text-[#101935]">Concierge</span>
          </div>
          <div className="text-[#535862] font-inter text-base ml-6">
            Request Pharma Support, Medication Samples and more...
          </div>
        </li>
      </Link>
    </ul>
  );

  return {
    MENU_INFO,
    MENU_INFO_MOBILE,
    NAVBAR_INFO_MOBILE,
    POPUP_CONTENT,
    open,
    setOpen,
  };
};
